import { render, staticRenderFns } from "./StatementBreakdown.vue?vue&type=template&id=48882f55&scoped=true"
import script from "./StatementBreakdown.vue?vue&type=script&lang=js"
export * from "./StatementBreakdown.vue?vue&type=script&lang=js"
import style0 from "./StatementBreakdown.vue?vue&type=style&index=0&id=48882f55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48882f55",
  null
  
)

export default component.exports